import { useState } from 'react'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'

import { useCanUI } from 'hooks/useCanUI'
import ModalCreateMember from './ModalCreateMember'
import ModalCreateDrdMember from './ModalCreateDrdMember'

const Buttons = (): JSX.Element => {
  const { isMemberLookupCreateMember, isMemberLookupCreateDRDMember } =
    useCanUI()

  const [showCreateMember, showCreateMemberSet] = useState<boolean>(false)
  const [showCreateDrdMember, showCreateDrdMemberSet] = useState<boolean>(false)

  return (
    <>
      {isMemberLookupCreateMember && (
        <button
          className="px-3 py-1 mx-1 border rounded-md border-primary text-primary"
          onClick={() => showCreateMemberSet(true)}
          type="button"
        >
          <Icon icon={faPlus} className="mr-2" />
          <span className="tracking-wider font-light">Create Member</span>
        </button>
      )}

      {isMemberLookupCreateDRDMember && (
        <button
          className="px-3 py-1 mx-1 border rounded-md border-primary text-primary"
          onClick={() => showCreateDrdMemberSet(true)}
          type="button"
        >
          <Icon icon={faPlus} className="mr-2" />
          <span className="tracking-wider font-light">Create DRD Member</span>
        </button>
      )}

      <ModalCreateMember
        title="Create Member"
        open={showCreateMember}
        onClose={() => showCreateMemberSet(false)}
      />
      <ModalCreateDrdMember
        title="Create DRD Member"
        open={showCreateDrdMember}
        onClose={() => showCreateDrdMemberSet(false)}
      />
    </>
  )
}

export default Buttons
